import PropTypes from "prop-types";
export const titleProptypes = {
  children: PropTypes.node.isRequired,
  titleType: PropTypes.number,
  noMargin: PropTypes.bool,
  textAlign: PropTypes.string
};
